import { connect } from 'react-redux';
import { push } from 'redux-first-history';
import paths from '@rental-manager/pathsManifest';
import OneTimePaymentPage from './component';
import { DEFAULT_ERROR, ONE_TIME_PAYMENT_REQUEST_SUCCESS } from '@rental-manager/constants/NotificationConstants';
import { createOneTimePayment, getIreneDashboard } from '@rental-manager/actions/requests';
import { closeNotification, showModalNotification, showPageNotification } from '@common/actions/NotificationActions';
import FeaturePermissionTypes from '@rental-manager/constants/FeaturePermissionTypes';
import DismissibleActionConstants from '@common/constants/DismissibleActionConstants';
import { logError } from '@zg-rentals/log-error';

const mapStateToProps = (state) => {
  const { currentTerm, nextTerm, oneTimePaymentRequest, featurePermissions, dismissibleActions } =
    state.payments.landlord.property;

  const paymentPlanEnabled =
    featurePermissions?.[currentTerm.rentTermsKey]?.[FeaturePermissionTypes.RENTAL_PROTECTION_PAYMENT_PLAN].isAllowed;
  const rentTermsKeyArray = [currentTerm.rentTermsKey];
  const tenantNameArray = [currentTerm.tenantName];
  const oneTimePaymentLimitsArray = [currentTerm.oneTimePaymentLimits];

  if (nextTerm.rentTermsKey) {
    rentTermsKeyArray.push(nextTerm.rentTermsKey);
    tenantNameArray.push(nextTerm.tenantName);
    oneTimePaymentLimitsArray.push(nextTerm.oneTimePaymentLimits);
  }

  return {
    rentTermsKeyArray,
    tenantNameArray,
    oneTimePaymentLimitsArray,
    oneTimePaymentRequest,
    paymentPlanEnabled,
    dismissibleActions,
  };
};

const mapDispatchToProps = (dispatch, { baseUrl, propertyId }) => ({
  onSubmit: async ({ rentTermsKey, amount, type, notes }) => {
    try {
      await dispatch(closeNotification());
      await dispatch(
        createOneTimePayment({
          propertyId,
          rentTermsKey,
          amount,
          type,
          notes,
        }),
      );

      return { success: true };
    } catch (err) {
      logError({ error: err });
      await dispatch(showModalNotification(DEFAULT_ERROR));
      return { error: true };
    }
  },
  onClose: async () => {
    await dispatch(closeNotification());
    await dispatch(push(baseUrl));
    await dispatch(getIreneDashboard({ propertyId })).catch(logError);
  },
  goToDashboard: async (tenantFirstName) => {
    await dispatch(push(baseUrl));
    await dispatch(getIreneDashboard({ propertyId })).catch(logError);
    await dispatch(showPageNotification(ONE_TIME_PAYMENT_REQUEST_SUCCESS, { tenantFirstName }));
  },
  goToSetupPaymentPlan: async (dismissibleActions): Promise<any> => {
    await dispatch(closeNotification());
    return dismissibleActions[DismissibleActionConstants.PAYMENT_PLAN_INSTRUCTIONS]
      ? dispatch(push(baseUrl + paths.dashboard.howToSetupPaymentPlan))
      : dispatch(push(baseUrl + paths.dashboard.PaymentPlanInstallmentRequests));
  },
});
const mergeProps = (stateProps, dispatchProps) => {
  const { dismissibleActions } = stateProps;
  return {
    ...stateProps,
    ...dispatchProps,
    goToSetupPaymentPlan: () => dispatchProps.goToSetupPaymentPlan(dismissibleActions),
  };
};

export default connect(mapStateToProps, mapDispatchToProps, mergeProps)(OneTimePaymentPage);
